import { render } from "./AddUserModal.vue?vue&type=template&id=48694bb8&ts=true"
import script from "./AddUserModal.vue?vue&type=script&lang=ts"
export * from "./AddUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__